import { BetLeftCommand, BetRightCommand, DoubleBetCommand, PlaceBetCommand } from './betting-commands';
import { IBetCommand, IBettingSystem } from './interfaces';

export function deserialize(bettingSystem: IBettingSystem, data: object): IBetCommand {
    switch (data['type']) {
        case 'PlaceBetCommand':
            return PlaceBetCommand.deserialize(bettingSystem, data);
        case 'BetLeftCommand':
            return BetLeftCommand.deserialize(bettingSystem, data);
        case 'BetRightCommand':
            return BetRightCommand.deserialize(bettingSystem, data);
        case 'DoubleBetCommand':
            return DoubleBetCommand.deserialize(bettingSystem);
        default:
            throw new Error('Unknown command type');
    }
}
